import { render, staticRenderFns } from "./PatientProfileModalSkeleton.vue?vue&type=template&id=44f186ac&"
import script from "./PatientProfileModalSkeleton.vue?vue&type=script&lang=js&"
export * from "./PatientProfileModalSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./PatientProfileModalSkeleton.vue?vue&type=style&index=0&id=44f186ac&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44f186ac')) {
      api.createRecord('44f186ac', component.options)
    } else {
      api.reload('44f186ac', component.options)
    }
    module.hot.accept("./PatientProfileModalSkeleton.vue?vue&type=template&id=44f186ac&", function () {
      api.rerender('44f186ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/PatientProfile/components/common/PatientProfileModalSkeleton.vue"
export default component.exports